import { z } from 'zod';

export enum EDIT_ORGANIZATION_FORM {
	NAME = 'name',
	CONTACT_EMAIL = 'contactEmail',
}

export const EditOrganizationShape = () =>
	z.object({
		[EDIT_ORGANIZATION_FORM.NAME]: z.string().trim().min(1, 'Required'),
		[EDIT_ORGANIZATION_FORM.CONTACT_EMAIL]: z
			.string()
			.trim()
			.email()
			.optional()
			.or(z.literal('')),
	});

export type EditOrganizationFormValues = z.infer<ReturnType<typeof EditOrganizationShape>>;
